import React from 'react';
import { AgenciesList } from '../../components/Views/AgenciesPage';
import { getSeoData } from '../../utils/helpers';
import { Layout } from '../../components/Layout/Layout';
import { agenciesQuery } from '../../api/queries';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { getSSRContextData } from '../../utils/helpers/ssrContext';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { readMockFile } from '../../utils/helpers/readMockFile';
import { mapAgencyConnectionToNodes } from '../../utils/helpers/agenciesConnection';
import { AGENCIES_PAGE_SIZE } from '../../utils/constants/agencies';
import { AgencySort } from '../../graphql/graphql';
import { shouldUseMock } from '../../utils/helpers/shouldUseMock';

const Agencies = props => <AgenciesList {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ req, query }) => {
    const { platform } = getSSRContextData(req);
    const currentLang = getLocaleOnSSR(req);

    const apolloClient = initApollo({}, { lang: currentLang, platform });
    const asPath = '/agentlikler';

    if (shouldUseMock(query)) {
      const mock = await readMockFile('agenciesMockData.json');

      return {
        props: {
          seoData: {},
          initialAgencies: mock.data.agencies,
          agenciesPageInfo: { hasNextPage: false, endCursor: null },
          agenciesTotalCount: mock.data.agencies.length,
          hasError: false,
          currentLang
        }
      };
    }

    const [seoData, agenciesRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req, true),
      apolloClient.query({
        query: agenciesQuery,
        variables: {
          first: AGENCIES_PAGE_SIZE,
          sort: AgencySort.Random
        },
        fetchPolicy: 'no-cache'
      }),
      getStaticData(apolloClient)
    ]);

    const connection = agenciesRes?.data?.agencies;

    return {
      props: {
        seoData,
        ...staticData,
        initialAgencies: mapAgencyConnectionToNodes(connection),
        agenciesPageInfo: connection?.pageInfo ?? {
          hasNextPage: false,
          endCursor: null
        },
        agenciesTotalCount: connection?.totalCount ?? 0,
        hasError: false,
        currentLang
      }
    };
  },
  '/agencies',
  {
    seoData: {},
    keywords: [],
    citiesUnPopularList: [],
    regions: {},
    initialAgencies: [],
    agenciesPageInfo: { hasNextPage: false, endCursor: null },
    agenciesTotalCount: 0,
    hasError: true
  }
);

Agencies.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Agencies;
